export default __webpack_public_path__ + "static/media/red-color-palette.7b8c5897.png";